import Reveal, { Eyebrow } from "./Reveal";
import { PhoneIncoming, PhoneOutgoing, Languages, FileText, ScrollText } from "lucide-react";

const ITEMS = [
  {
    icon: PhoneIncoming,
    title: "Inbound",
    body: "Answers inbound calls and books, confirms, or takes a message.",
  },
  {
    icon: PhoneOutgoing,
    title: "Outbound",
    body: "Makes outbound calls — reminders, confirmations, follow-ups, reactivations.",
  },
  {
    icon: Languages,
    title: "Languages",
    body: "Speaks Hindi, English and Bengali, and follows the customer if they switch language mid-call.",
  },
  {
    icon: FileText,
    title: "Every call, on file",
    body: "Records every call: disposition, full transcript, recording and captured fields.",
  },
  {
    icon: ScrollText,
    title: "One prompt per agent",
    body: "Dialogue, flow, dispositions and closings in a single versioned prompt. No scattered scripts.",
  },
];

const AgentCapabilities = () => (
  <section data-testid="capabilities-section" className="py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow>What an agent does</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]">
              One agent.
              <br />
              Every phone job
              <br />
              your team repeats.
            </h2>
            <p className="text-zinc-600 mt-6 leading-relaxed max-w-md">
              Voicxent does not replace your people. It does the calling at scale — and your people
              work the queue: the escalations, the approvals, and the conversations that need a human.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7 flex flex-col">
          {ITEMS.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.06}>
              <div
                data-testid={`capability-item-${i + 1}`}
                className="group flex gap-5 sm:gap-8 py-6 border-b border-zinc-200 first:border-t items-start hover:bg-white hover:px-5 sm:hover:px-8 -mx-0 transition-all duration-500"
              >
                <span className="font-mono2 text-xs text-zinc-400 pt-2 w-7 shrink-0">0{i + 1}</span>
                <item.icon size={22} className="text-[#2563EB] mt-1.5 shrink-0 transition-transform duration-500 group-hover:scale-110" />
                <div>
                  <h3 className="font-display font-bold text-lg sm:text-xl text-zinc-900">{item.title}</h3>
                  <p className="text-zinc-600 mt-1.5 leading-relaxed text-sm sm:text-base">{item.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default AgentCapabilities;
